module.exports = __webpack_public_path__ + "img/muchAboveNormal.b324a7ae.svg";